import { useCallback, useEffect } from 'react';
import { useWriteContract, useWaitForTransactionReceipt } from 'wagmi';

import {
  SANKO_WAGER_ADDR,
  dmtContract,
  DMT_TOTAL_SUPPLY,
} from '@src/lib/consts';

import { _useDispatch } from '@src/state/hooks';
import { pushEventQueue } from '@src/state/slices/slice_game';
import { setShowFullViewLoader } from '@src/state/slices/slice_app';

export default function useWagerApprove() {
  const dispatch = _useDispatch();

  const onError = useCallback((e: unknown) => {
    console.error(e);
    // hide loader
    dispatch(setShowFullViewLoader(false));
    dispatch(
      pushEventQueue({
        message: 'Did not update $GOLD allowance',
        showToast: true,
        sound: 'error',
      }),
    );
  }, []);

  const { data: writeData, writeContract: approve } = useWriteContract({
    mutation: {
      onMutate: () => {
        // show loader
        dispatch(setShowFullViewLoader(true));
        console.log('onMutate approve');
      },
      onError,
    },
  });

  const approveWrapper = useCallback(() => {
    approve({
      ...dmtContract,
      functionName: 'approve',
      args: [SANKO_WAGER_ADDR, DMT_TOTAL_SUPPLY],
    });
  }, [approve]);

  const { isSuccess, isError } = useWaitForTransactionReceipt({
    hash: writeData,
    query: {
      enabled: !!writeData,
    },
  });

  useEffect(() => {
    if (isSuccess) {
      dispatch(setShowFullViewLoader(false));
      console.log('onSuccess approve');
      dispatch(
        pushEventQueue({
          message: 'Updated $GOLD allowance',
          showToast: true,
          sound: 'sanko',
        }),
      );
    }
    if (isError) {
      onError('Transaction failed');
    }
  }, [isSuccess, isError, dispatch, onError]);

  return approveWrapper;
}
